export const WARNING_ICON_PATH = "../images/ic_warning_outlined.svg";

export enum RecordType {
  Entry = 1,
  Exit = 2,
}

export enum MovementListTableColumn {
  AnimalCategory = "animal-category",
  RecordType = "record-type",
  Quantity = "quantity",
  OperationDate = "operation-date",
  OperationType = "operation-type",
  Weight = "weight",
  CarcassYield = "carcass-yield",
  Edit = "edit",
  Delete = "delete",
}

/**
 * Converts a numeric carcass yield value to a localized string representation.
 * If the value is `null` or `undefined`, returns `null`.
 * Otherwise, converts the number to a string and replaces the decimal point with a comma.
 */
export function getLocalCarcassYield(
  value: number | null | undefined
): string | null {
  if (value == null) {
    return null;
  }

  return value.toString().replace(".", ",");
}

/**
 * Parses a string representing a carcass yield value and converts it to a number.
 *
 * If the input value is `null` or an empty string, returns `null`.
 * Handles both comma and dot as decimal separators.
 */
export function parseCarcassYield(value: string | null): number | null {
  if (value == null || value.trim() === "") {
    return null;
  }

  const parsedValue = parseFloat(value.replace(",", "."));
  return parsedValue;
}

/**
 * Formats a carcass yield input value by replacing the decimal point with a comma,
 * and ensuring that only up to two decimal digits are present after the comma.
 */
export function formatCarcassYieldInput(value: string | null): string | null {
  if (value == null) {
    return null;
  }

  const valueWithCommas = value.replace(".", ",");

  if (!valueWithCommas.includes(",")) {
    return valueWithCommas;
  }

  const splittedValues = valueWithCommas.split(",");

  return splittedValues.length >= 2
    ? [splittedValues[0], splittedValues[1].substring(0, 2)].join(",")
    : valueWithCommas;
}
